import _regeneratorRuntime from "babel-runtime/regenerator";
import _Promise from "babel-runtime/core-js/promise";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _extends from "babel-runtime/helpers/extends";
import _Object$assign from "babel-runtime/core-js/object/assign";
import sysConfig from "../config/sysConfig";
import definecfg from "../config/defineConfig.js";
import storage from "../tools/storage.js";
import oppService from "./opp-service";
import baseConfig from "../config/baseConfig";

export default {
  getCSDCAcctData: function getCSDCAcctData(_this, custFname, idType, idCode, custName) {
    var that = this;
    return sysConfig.$syscfg.K_Request("Y3001002", {
      F_CUST_ORG_CODE: storage.$storage.getSession(definecfg.$definecfg.F_CUST_ORG_CODE),
      ACCTBIZ_EXCODE: "07",
      CHK_STATUS: "2",
      CUST_FNAME: custFname,
      CUST_NAME: custName,
      ID_CODE: idCode,
      ID_TYPE: idType,
      OPERATOR_TYPE: "0",
      USER_TYPE: _this.userType,
      BUSI_CODE: _this.busiCode
    }, true).then(function (data) {
      return that.queryCSDCTime().then(function (isInCsdcTime) {
        if (isInCsdcTime == "true") {
          if (data.Code == "0") {
            return data.Data;
          } else {
            consoleLog("获取证券账号数据失败,原因：" + data.Msg);
            return [];
          }
        } else {
          return [];
        }
      });
    }).catch(function (err) {
      return [];
    });
  },
  getCSDCYmtData: function getCSDCYmtData(_this, custFname, idType, idCode, custName) {
    var that = this;
    return sysConfig.$syscfg.K_Request("Y3001002", {
      F_CUST_ORG_CODE: storage.$storage.getSession(definecfg.$definecfg.F_CUST_ORG_CODE),
      ACCTBIZ_EXCODE: "08",
      CHK_STATUS: "2",
      ACCTBIZ_CLS: "03",
      CUST_NAME: custName,
      OPERATOR_TYPE: "0",
      CUST_FNAME: custFname,
      ID_CODE: idCode,
      ID_TYPE: idType,
      USER_TYPE: _this.userType,
      BUSI_CODE: _this.busiCode
    }, true).then(function (data) {
      return that.queryCSDCTime().then(function (isInCsdcTime) {
        if (isInCsdcTime == "true") {
          if (data.Code == "0") {
            return data.Data;
          } else {
            consoleLog("获取中登一码通数据失败,原因：" + data.Msg);
            return [];
          }
        } else {
          return [];
        }
      });
    }).catch(function (err) {
      return [];
    });
  },
  queryCSDCYMTData: function queryCSDCYMTData(param) {
    var that = this;
    return that.queryCSDCTime().then(function (isInCsdcTime) {
      if (isInCsdcTime == "true") {
        return sysConfig.$syscfg.K_Request("Y1001134", {
          ID_CODE: param.ID_CODE,
          ID_TYPE: param.ID_TYPE,
          CUST_FNAME: param.CUST_FNAME
        }).then(function (data) {
          if (data.Code == "0") {
            return data.Data || [];
          } else {
            return [];
          }
        });
      }
      return [];
    });
  },
  getCSDCAgreeMentData: function getCSDCAgreeMentData(custFname, idType, idCode, agmtType, acctList, params) {
    var that = this;
    return sysConfig.$syscfg.K_Request("W0000148", _Object$assign({
      CUST_FNAME: custFname,
      ID_TYPE: idType,
      ID_CODE: idCode,
      PROPER_CLS: agmtType,
      ACCT_LIST: acctList || [],
      ACCTBIZ_EXCODE: "13",
      OPERATOR_TYPE: "0",
      ACCTBIZ_CLS: "02",
      CHK_STATUS: "2",
      F_CUST_ORG_CODE: storage.$storage.getSession(definecfg.$definecfg.F_CUST_ORG_CODE)
    }, params)).then(function (data) {
      return that.queryCSDCTime().then(function (isInCsdcTime) {
        if (isInCsdcTime == "true") {
          if (data.Code == "0") {
            return data.Data;
          } else {
            consoleLog("获取中登一码通数据失败,原因：" + data.Msg);
            return [];
          }
        } else {
          return [];
        }
      });
    });
  },
  queryCSDCTime: function queryCSDCTime(sysCode) {
    return sysConfig.$syscfg.K_Request("F0000106", {
      SYS_CODE: sysCode || "11" }).then(function (res) {
      if (res.Code == "0") {
        return res.Data[0] && res.Data[0].CHECK_FLAG;
      } else {
        throw "判断是否在中登时间内请求失败,原因：" + res.Msg;
      }
    });
  },
  queryCSDCDateAndTime: function queryCSDCDateAndTime(sysCode) {
    return sysConfig.$syscfg.K_Request("Y3006013", {
      SYS_CODE: sysCode || "11" }).then(function (res) {
      if (res.Code == "0") {
        return _.get(res, "Data[0].SYS_STAT") == "1" ? "true" : "false";
      } else {
        throw "判断是否在中登时间内请求失败,原因：" + res.Msg;
      }
    });
  },
  getCDSCFirstTrdDate: function getCDSCFirstTrdDate(custName, idType, idCode, filterAcctType) {
    var that = this;
    return sysConfig.$syscfg.K_Request("W0000105", {
      ACCTBIZ_EXCODE: "09",
      CHK_STATUS: "2",
      CUST_FNAME: custName,
      ID_CODE: idCode,
      ID_TYPE: idType,
      OPERATOR_TYPE: "0"
    }).then(function (res) {
      return that.queryCSDCTime().then(function (isInCsdcTime) {
        if (isInCsdcTime == "true") {
          if (res.Code == "0") {
            var firstTrdDate = "0";
            var arr = res.Data;
            filterAcctType = filterAcctType || [];
            var filterArr = _.isArray(filterAcctType) ? filterAcctType : filterAcctType.split(",");
            if (arr && arr.length > 0) {
              var qsVersion = oppService.getBusiCommonParamsFromCacheObjs("QSJGDM_FILTER") ? oppService.getBusiCommonParamsFromCacheObjs("QSJGDM_FILTER").split(",") : [];

              arr = _.chain(arr).filter(function (obj) {
                obj.FIRST_TRD_DATE = _.trim(obj.FIRST_TRD_DATE);

                if (_.includes(qsVersion, baseConfig.$basecfg.qsVersion)) {
                  return obj.FIRST_TRD_DATE != "" && obj.FIRST_TRD_DATE != "0" && obj.FIRST_TRD_DATE != "19000101" && (obj.ACCT_STATUS == "0" || obj.ACCT_STATUS == "4" || obj.ACCT_STATUS == "9");
                } else {
                  return obj.FIRST_TRD_DATE != "" && obj.FIRST_TRD_DATE != "0";
                }
              }).filter(function (v) {
                if (filterArr.length) {
                  return _.indexOf(filterArr, v.ACCT_TYPE) != -1;
                } else {
                  return true;
                }
              }).sortBy("FIRST_TRD_DATE").map(function (obj) {
                return obj.FIRST_TRD_DATE;
              }).value();
              firstTrdDate = arr && arr[0];
            }
            return firstTrdDate;
          } else {
            consoleLog("获取客户首次交易日失败,原因：" + res.Msg);
            return "0";
          }
        } else {
          return "";
        }
      });
    });
  },
  getCSDCTrdacctData: function getCSDCTrdacctData(param, ajaxObj, ignoreError) {
    return sysConfig.$syscfg.K_Request("F0000000", _extends({
      SERVICE_CODE: "Y3001002",
      OPERATOR_TYPE: "0",
      ACCTBIZ_EXCODE: param.ACCTBIZ_EXCODE,
      CHK_STATUS: param.CHK_STATUS || "2",
      ACCTBIZ_CLS: param.ACCTBIZ_CLS,
      CUST_CODE: param.CUST_CODE,
      CUST_FNAME: param.CUST_FNAME,
      ID_TYPE: param.ID_TYPE,
      ID_CODE: param.ID_CODE,
      YMT_CODE: param.YMT_CODE,
      USER_TYPE: param.USER_TYPE,
      TRDACCT: param.TRDACCT,
      ACCT_TYPE: param.ACCT_TYPE,
      TA_CODE: param.TA_CODE,
      OF_ACCT: param.OF_ACCT,
      MOBILE_TEL: param.MOBILE_TEL,
      F_CUST_ORG_CODE: param.F_CUST_ORG_CODE
    }, ajaxObj || {}), true, ignoreError).then(function (res) {
      if (res.Code == "0") {
        return res.Data ? res.Data : [];
      } else {
        if (ignoreError) {
          return [];
        } else {
          throw "获取中登正常账户和一码通号码请求失败，原因：" + res.Msg;
        }
      }
    });
  },
  getCancelYmtCode: function getCancelYmtCode(urlParam, sysTrdacct) {
    var _this2 = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
      var that, csdcTrdacctList, csdcYmtList, sysTrdacctList, csdcYmtTrdacctObj, cancelCsdcYmtArr, isIncsdc, ymtkey, ymtCode, existOtherInCsdc;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              that = _this2;
              csdcTrdacctList = void 0;
              csdcYmtList = void 0;
              sysTrdacctList = _.uniq(sysTrdacct.map(function (v) {
                return v.TRDACCT;
              }));
              csdcYmtTrdacctObj = void 0;
              cancelCsdcYmtArr = [];
              _context.next = 8;
              return that.queryCSDCTime().then(function (data) {
                return data == "true";
              });

            case 8:
              isIncsdc = _context.sent;

              if (isIncsdc) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", "");

            case 11:
              _context.next = 13;
              return _Promise.all([that.getCSDCTrdacctData({
                CUST_FNAME: urlParam.CUST_FNAME,
                ID_TYPE: urlParam.ID_TYPE === "0J" ? "00" : urlParam.ID_TYPE,
                ID_CODE: urlParam.ID_CODE,
                ACCTBIZ_EXCODE: "08"
              }, { noProcess: true }, true), that.getCSDCTrdacctData({
                CUST_FNAME: urlParam.CUST_FNAME,
                ID_TYPE: urlParam.ID_TYPE === "0J" ? "00" : urlParam.ID_TYPE,
                ID_CODE: urlParam.ID_CODE,
                ACCTBIZ_EXCODE: "07"
              }, { noProcess: true }, true)]).then(function (res) {
                csdcYmtList = res[0].filter(function (v) {
                  return v.YMT_STATUS != "1";
                });
                csdcTrdacctList = res[1];
              });

            case 13:
              if (!csdcYmtList.length) {
                _context.next = 17;
                break;
              }

              csdcYmtList.map(function (ymt) {
                var ymtCode = ymt.YMT_CODE,
                    existCsdcTrdacct = _.find(csdcTrdacctList, function (trdacct) {
                  return ymtCode === trdacct.YMT_CODE && trdacct.ACCT_STATUS !== "9";
                });
                !existCsdcTrdacct && !cancelCsdcYmtArr.includes(ymtCode) && cancelCsdcYmtArr.push(ymtCode);
              });
              _context.next = 18;
              break;

            case 17:
              return _context.abrupt("return", "");

            case 18:
              csdcYmtTrdacctObj = csdcTrdacctList.reduce(function (acc, trdacct) {
                var ymtCode = trdacct.YMT_CODE,
                    ymtKey = "y" + ymtCode;
                if (trdacct.YMT_STATUS !== "1" && trdacct.ACCT_STATUS !== "9") {
                  if (!acc[ymtKey]) {
                    acc[ymtKey] = [];
                  }
                  !acc[ymtKey].includes(trdacct.TRDACCT) && acc[ymtKey].push(trdacct.TRDACCT);
                }
                return acc;
              }, {});

              for (ymtkey in csdcYmtTrdacctObj) {
                ymtCode = ymtkey.substring(1), existOtherInCsdc = _.find(csdcYmtTrdacctObj[ymtkey], function (trdacct) {
                  return !sysTrdacctList.includes(trdacct);
                });

                !existOtherInCsdc && !cancelCsdcYmtArr.includes(ymtCode) && cancelCsdcYmtArr.push(ymtCode);
              }
              return _context.abrupt("return", cancelCsdcYmtArr.join(","));

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  getDestroyCreditAccountInDay30: function getDestroyCreditAccountInDay30(paramObj) {
    var reqParams = {
      CUST_CODE: paramObj.CUST_CODE,
      CUST_FNAME: paramObj.CUST_FNAME,
      ID_TYPE: paramObj.ID_TYPE,
      ID_CODE: paramObj.ID_CODE
    };
    return sysConfig.$syscfg.K_Request("Y1000419", reqParams).then(function (res) {
      if (res.Code != "0") {
        throw res.Msg;
        return;
      }
      return _.get(res, "Data[0]", []);
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/service/csdc-service.js
// module id = 198
// module chunks = 2